$(document).on('change', '#header__font', function(event) {
    event.preventDefault();
    var font = $(this).val();
    if (font) {
        $('body').removeClass(function(index, css) {
            return (css.match(/(^|\s)header-font-\S+/g) || []).join(' ');
        }).addClass('header-font-' + font);
        $(this).css('font-family', font);
    } else {
        $('body').removeClass(function(index, css) {
            return (css.match(/(^|\s)header-font-\S+/g) || []).join(' ');
        });
        $(this).css('font-family', 'inherit');
    }
});
$(document).on('change', '#body__font', function(event) {
    event.preventDefault();
    var font = $(this).val();
    if (font) {
        $('body').removeClass(function(index, css) {
            return (css.match(/(^|\s)body-font-\S+/g) || []).join(' ');
        }).addClass('body-font-' + font);
        $(this).css('font-family', font);
    } else {
        $('body').removeClass(function(index, css) {
            return (css.match(/(^|\s)body-font-\S+/g) || []).join(' ');
        });
        $(this).css('font-family', 'inherit');
    }
});
